export interface GkCategory {
  slug: string;
  name: string;
  tagline: string;
  description: string;
  color: string;
  icon: string;
  image: string;
}

export const gkCategories: GkCategory[] = [
  {
    slug: "mingxing",
    name: "明星动态",
    tagline: "谁在营业，谁在发力",
    description: "追踪当红艺人新动态、行程路透与舞台幕后，看谁正霸屏热搜。",
    color: "primary",
    icon: "ri-star-fill",
    image: "https://readdy.ai/api/search-image?query=%E7%B4%A0%E9%9B%85%E6%98%8E%E6%98%9F%E7%A7%80%E5%9C%BA%E8%83%8C%E5%BD%B1%E9%9B%AA%E7%BA%B1%E8%A3%99%E9%AB%98%E5%85%89%E7%BA%A2%E6%AF%AF%E5%9C%B0%E6%AF%AF%E4%B8%8A%E7%9A%84%E9%97%AA%E5%85%89%E7%81%AF%2C%E6%BC%82%E4%BA%AE%E5%85%83%E7%B4%A0%E6%9C%A6%E8%83%A7%E7%9A%84%E8%88%9E%E5%8F%B0%E5%85%89%E5%BD%B1%2C%E9%AB%98%E9%9B%85%E5%90%8D%E5%AA%9B%E5%85%B8%E7%A4%BC%E7%8E%B0%E5%9C%BA&width=900&height=600&seq=gk-star-01&orientation=landscape",
  },
  {
    slug: "zongyi",
    name: "综艺现场",
    tagline: "舞台背后的真性情",
    description: "热门综艺录制内幕、爆笑名场面与嘉宾互动高光时刻一网打尽。",
    color: "accent",
    icon: "ri-mic-fill",
    image: "https://readdy.ai/api/search-image?query=%E7%BB%BC%E8%89%BA%E8%8A%82%E7%9B%AE%E5%BD%95%E5%88%B6%E7%8E%B0%E5%9C%BA%E6%BC%82%E4%BA%AE%E7%81%AF%E5%85%89%E5%92%8C%E8%88%9E%E5%8F%B0%E5%B8%83%E7%BD%AE%2C%E5%A4%9A%E5%8F%B0%E6%91%84%E5%83%8F%E6%9C%BA%E4%B8%8E%E5%B7%A5%E4%BD%9C%E4%BA%BA%E5%91%98%2C%E7%83%AD%E9%97%B9%E6%AC%A2%E4%B9%90%E7%9A%84%E8%8A%82%E7%9B%AE%E7%8E%B0%E5%9C%BA%E6%B0%9B%E5%9B%B4%2C%E8%89%B2%E5%BD%A9%E9%B2%9C%E4%BA%AE%E7%9A%84%E7%8A%B6%E6%80%81&width=900&height=600&seq=gk-var-01&orientation=landscape",
  },
  {
    slug: "yingshi",
    name: "影视热播",
    tagline: "好剧好片，谁在追",
    description: "新剧开播、收视战报、角色解读与幕后花絮，追剧人必看指南。",
    color: "primary",
    icon: "ri-clapperboard-fill",
    image: "https://readdy.ai/api/search-image?query=%E7%94%B5%E5%BD%B1%E9%99%A2%E6%BC%82%E4%BA%AE%E7%BA%A2%E6%AF%AF%E5%92%8C%E5%85%A5%E5%9C%BA%E9%97%A8%2C%E7%83%AD%E6%92%AD%E7%94%B5%E5%BD%B1%E6%B5%B7%E6%8A%A5%E5%92%8C%E6%98%8E%E6%98%9F%E9%80%A0%E5%9E%8B%2C%E5%AE%A3%E4%BC%A0%E5%91%A8%E8%BE%B9%E7%89%A9%E4%BB%B6%E6%91%86%E8%AE%BE%2C%E7%94%B5%E5%BD%B1%E5%85%83%E7%B4%A0%E8%89%B2%E5%BD%A9&width=900&height=600&seq=gk-film-01&orientation=landscape",
  },
  {
    slug: "yinyue",
    name: "音乐现场",
    tagline: "旋律背后的故事",
    description: "演唱会、新歌首发与榜单热曲背后，记录歌手与歌迷的双向奔赴。",
    color: "secondary",
    icon: "ri-music-2-fill",
    image: "https://readdy.ai/api/search-image?query=%E6%BC%94%E5%94%B1%E4%BC%9A%E7%8E%B0%E5%9C%BA%E6%BC%82%E4%BA%AE%E8%89%B2%E5%BD%A9%E7%81%AF%E5%85%89%E6%89%93%E5%87%BA%E5%92%8C%E6%BC%94%E5%94%B1%E8%80%85%E9%80%A0%E5%9E%8B%E8%83%8C%E5%BD%B1%2C%E7%B2%89%E4%B8%9D%E6%8C%A5%E8%88%9E%E7%9A%84%E6%89%8B%E6%9C%BA%E7%81%AF%E6%B5%B7%2C%E8%88%9E%E5%8F%B0%E6%B0%9B%E5%9B%B4%E7%83%AD%E9%97%B9&width=900&height=600&seq=gk-mus-01&orientation=landscape",
  },
  {
    slug: "shejiao",
    name: "社交热榜",
    tagline: "全网在聊什么",
    description: "热搜发酵、话题破圈与网友神评，第一时间读懂全民在讨论的新热点。",
    color: "accent",
    icon: "ri-fire-fill",
    image: "https://readdy.ai/api/search-image?query=%E7%A4%BE%E4%BA%A4%E5%AA%92%E4%BD%93%E6%89%8B%E6%9C%BA%E6%91%87%E4%B8%80%E6%91%87%E5%92%8C%E5%B9%B3%E6%9D%BF%E7%94%B5%E8%84%91%2C%E5%B1%8F%E5%B9%95%E4%B8%8A%E6%98%BE%E7%A4%BA%E7%81%AB%E7%83%AD%E8%AF%9D%E9%A2%98%E5%92%8C%E6%8A%95%E7%A5%A8%E5%9B%BE%E6%A0%87%2C%E6%B8%85%E6%96%B0%E7%A4%BE%E4%BA%A4%E5%85%83%E7%B4%A0%E6%8F%92%E7%94%BB&width=900&height=600&seq=gk-soc-01&orientation=landscape",
  },
];